<div class="visitor-leave-summary">
    <h1>{{'' | translate:
        ['tmc-yard.widgets.registration-terminal.visitor-leave-summary.description',
        translationService.language]}}</h1>

    <div class="success">
        <sc-icon iconClass="fa-check-circle"></sc-icon>
    </div>

</div>
